import type { BreadcrumbNavigationV1Attributes } from '@/features/breadcrumb-navigation-v1-desktop/breadcrumb-navigation-v1-type';

import { Fragment } from 'react';

import { ChevronFullIcon } from '@/assets/icons/chevron-full';
import { Link } from '@/core/features';
import color from '@/core/features/styles/color';

export type BreadcrumbNavigationV1DesktopProps = BreadcrumbNavigationV1Attributes;

export default function BreadcrumbNavigationV1Desktop({ breadcrumbs }: BreadcrumbNavigationV1DesktopProps) {
    return (
        <div className={'flex-start-center width-100 font-size-12 gap-10'}>
            {breadcrumbs.map((part) => {
                if (part.linkUrl) {
                    return (
                        <Fragment key={part.linkText}>
                            <Link
                                className={'text-nowrap'}
                                highlight={true}
                                href={part.linkUrl}
                                linkType={'internal'}
                                qaId={'qa-breadcrumb-desktop'}
                            >
                                {part.linkText}
                            </Link>
                            <ChevronFullIcon
                                color={color('mineShaft')}
                                height={10}
                                width={10}
                            />
                        </Fragment>
                    );
                }
                return (
                    <div
                        className={'ellipsis'}
                        key={`${part.linkText}`}
                    >
                        {part.linkText}
                    </div>
                );
            })}
        </div>
    );
}
